// frontend/src/components/MapVehicleMarker.js

import React from 'react';
import { Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';

// Define an SVG icon (a simple upward-pointing triangle)
const vehicleIconSvg = `
<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 2L2 22H22L12 2Z" fill="#F43F5E"/> //red color  
</svg>
`;

/* const vehicleIconSvg = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="6" y="10" width="12" height="8" fill="#2563EB"/>
  <circle cx="8" cy="18" r="2" fill="#2563EB"/>
  <circle cx="16" cy="18" r="2" fill="#2563EB"/>
  <path d="M12 2L2 10H22L12 2Z" fill="#2563EB"/>
</svg>
`; */

// Memoized component that only updates when the vehicle position changes
const MapVehicleMarker = React.memo(({ position, heading, showTooltips, t }) => {
  if (!position?.lat || !position?.lng) return null;

  const getRotatedVehicleIcon = (heading = 0) => {
    return L.divIcon({
      className: '',
      html: `<div style="
        width: 18px;
        height: 18px;
        transform: rotate(${heading}deg);
        transform-origin: center;
      ">${vehicleIconSvg}</div>`,
      iconSize: [18, 18],
      iconAnchor: [9, 9], // Center of the 18x18 icon
    });
  };

  return (
    <Marker
      position={[position.lat, position.lng]}
      icon={getRotatedVehicleIcon(heading)}
      zIndexOffset={1000} // Ensure vehicle is above other markers
    >
      <Tooltip
        permanent={true}
        direction="top"
        offset={[0, -5]}
        opacity={1}
        height={32}
        width={32}
        className="transparent-tooltip" // Custom class for styling
      >
        <span className="big-emoji">🚗</span> {/* Wrap emoji in a span for styling */}
      </Tooltip>
    </Marker>
  );
}, (prevProps, nextProps) => {
  // Custom comparison function - return TRUE to prevent re-render, FALSE to allow it
  if (!prevProps.position || !nextProps.position) {
    return !prevProps.position && !nextProps.position; // Equal if both null/undefined
  }

  return prevProps.position.lat === nextProps.position.lat &&
    prevProps.position.lng === nextProps.position.lng &&
    prevProps.heading === nextProps.heading;
});
MapVehicleMarker.displayName = 'MapVehicleMarker';

export default MapVehicleMarker;
